import useStore from 'stores/utils/hooks/useStore'
import { getClient } from 'api'
import { logAndTrackError } from 'utils/log/logAndTrackError'
import { trackVoucherActivation } from '../helpers/trackVoucherActivation'

interface UseVoucherActivationReturn {
  isVoucherActivated: boolean
  activateVoucher: (campaignId: string) => void
}

interface VoucherActivationRequest {
  advertisementId: string
  traversalId: string
  campaignId: string
  clientUuid: string
}

const postVoucherActivation = ({
  advertisementId,
  traversalId,
  campaignId,
  clientUuid
}: VoucherActivationRequest) =>
  getClient('apollo').post(`voucher/${advertisementId}/${traversalId}`, {
    campaignId,
    clientUuid
  })

const useVoucherActivation = (): UseVoucherActivationReturn => {
  const {
    traversalSession,
    traversal: { traversalId, data }
  } = useStore()

  const activateVoucher = (campaignId: string) => {
    if (traversalSession.isVoucherActivated) return

    traversalSession.setIsVoucherActivated(true)
    trackVoucherActivation(data, campaignId)

    if (!traversalId) {
      return
    }

    postVoucherActivation({
      advertisementId: data.system.advertisementId,
      traversalId,
      campaignId,
      clientUuid: data.system.clientUuid
    }).catch((error) => {
      traversalSession.setIsVoucherActivated(false)
      logAndTrackError(error)
    })
  }

  return {
    isVoucherActivated: traversalSession.isVoucherActivated,
    activateVoucher
  }
}

export default useVoucherActivation
